<div class="flex gap-3 text-sm">

	<div *ngIf="gsm"
		 class="fb-composition-container flex flex-col md:flex-row justify-center md:justify-between md:items-center">
		<div class="header flex gap-1.5 items-center mt-1">
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M8.31434 3.5625C8.31434 3.24756 8.43945 2.94551 8.66216 2.72281C8.88486 2.50011 9.18691 2.375 9.50186 2.375C9.8168 2.375 10.1189 2.50011 10.3416 2.72281C10.5643 2.94551 10.6894 3.24756 10.6894 3.5625C10.6894 3.87744 10.5643 4.17949 10.3416 4.40219C10.1189 4.62489 9.8168 4.75 9.50186 4.75C9.18691 4.75 8.88486 4.62489 8.66216 4.40219C8.43945 4.17949 8.31434 3.87744 8.31434 3.5625ZM12.8603 4.75C12.9902 4.37891 13.0644 3.97812 13.0644 3.5625C13.0644 1.5957 11.4687 0 9.50186 0C7.53503 0 5.93931 1.5957 5.93931 3.5625C5.93931 3.97812 6.00982 4.37891 6.14341 4.75H4.45491C3.6385 4.75 2.92599 5.30664 2.72559 6.10078L0.0536816 16.7883C-0.0799139 17.3189 0.0388377 17.883 0.376538 18.3172C0.714237 18.7514 1.23378 19 1.783 19H17.2207C17.7699 19 18.2858 18.7477 18.6235 18.3135C18.9612 17.8793 19.0799 17.3189 18.9463 16.7846L16.2744 6.09707C16.0777 5.30664 15.3652 4.75 14.5488 4.75H12.8603Z"/>
			</svg>
			Weight
		</div>
		<div class=" ">
			{{gsm}} GSM
		</div>
	</div>
	<div *ngIf="weight"
		 class="fb-composition-container flex flex-col md:flex-row md:items-center justify-center md:justify-between"
		 [ngClass]="!gsm? 'max-width': ''">
		<div class="header flex gap-1.5 items-center">
			<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path fill-rule="evenodd" clip-rule="evenodd" d="M17.9034 3.93757C17.0248 3.05889 15.6001 3.0589 14.7215 3.93757L3.93745 14.7216C3.05877 15.6002 3.05877 17.0249 3.93745 17.9036L9.09647 23.0626C9.97515 23.9412 11.3998 23.9412 12.2784 23.0626L23.0625 12.2786C23.9411 11.3999 23.9411 9.97527 23.0625 9.09659L17.9034 3.93757ZM11.7159 10.1251L12.9375 8.90357L15.517 11.4831L17.1079 9.89208L14.5284 7.31257L16.3125 5.52857L21.4715 10.6876L10.6875 21.4716L5.52845 16.3126L7.31245 14.5286L9.89195 17.1081L11.4829 15.5171L8.90345 12.9376L10.125 11.7161L12.7045 14.2956L14.2954 12.7046L11.7159 10.1251Z"/>
			</svg>

			Width
		</div>
		<div class=" ">
			{{ weight }}
		</div>
	</div>

</div>
